// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "c7186e9a2b80bc1a9a3f" + ".bundle.js";
};